import React from 'react';
import TpPrepaymentTpClientInvoiceLineItem from '../../../../Domain/TpPrepaymentTpClientInvoiceLineItem';
import TpClientInvoiceLineItemService from '../../../../Services/TpClientInvoiceLineItemService';
import ShowEntityData from '../../../../Elements/ShowEntityData';
import ShownPanelsEnum from '../../../../Enums/ShownPanelsEnum';
import TpPrepaymentProjectChangeItem from '../../../../Domain/TpPrepaymentProjectChangeItem';
import ChangeTpProjectPanel from './ChangeTpProjectPanel';

export default class TpClientPrePaymentDetailsInfoTab extends React.Component {
  static defaultProps = {
    prepaymentId: 0,
  };

  constructor(props) {
    super(props);

    this.state = {
      PrepaymentId: props.prepaymentId,
      shownPanel: ShownPanelsEnum.None,
      detailItem: {},
    };
    TpPrepaymentTpClientInvoiceLineItem.clickOnProjectChangeLink = this.clickOnProjectChangeLink.bind(this);
    this.showPanel = this.showPanel.bind(this);
  }

  clickOnProjectChangeLink(editItem) {
    const detailItem = new TpPrepaymentProjectChangeItem();
    detailItem.TpClientInvoiceId = editItem.TpClientInvoiceId;
    detailItem.ProjectId = editItem.ProjectId;
    detailItem.LineItemId = editItem.LineItemId;
    detailItem.ClientId = editItem.ClientId;
    this.setState({
      shownPanel: ShownPanelsEnum.EditSubItem,
      detailItem,
    });
  }

  renderOnePanel = (panelId, content) => (this.state.shownPanel === panelId ? content : null);

  showPanel(panelId) {
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  renderPanels() {
    return (
      <div>
        {this.renderOnePanel(
          ShownPanelsEnum.EditSubItem,
          <ChangeTpProjectPanel
            clickOnCancel={() => {
              this.setState({ shownPanel: ShownPanelsEnum.None });
            }}
            baseItem={this.state.detailItem}
          />
        )}
      </div>
    );
  }

  render() {
    return (
      <div>
        <ShowEntityData
          itemId={this.state.PrepaymentId}
          type={TpPrepaymentTpClientInvoiceLineItem}
          serviceGetByIdFunction={TpClientInvoiceLineItemService.GetById}
        />
        {this.renderPanels()}
      </div>
    );
  }
}
